import { Avatar, Button, Clickable, Col, Input, Modal, Row, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const ConcludeModal = ({ visible, closeModal, data }) => {
  const [winnerId, setWinnerId] = useState(null),
    [score, setScore] = useState(''),
    dispatch = useDispatch();

  useEffect(() => {
    setWinnerId(null);
    setScore('');
  }, [visible]);

  if (!data) return null;

  async function submit() {
    const res = await Api.post(
      '/admin/concludeEvent',
      {
        eventId: data._id,
        winnerId,
        score
      },
      'concludeEvent'
    );

    if (!res) return null;

    dispatch({
      type: 'ADMIN_UPDATE_EVENT',
      payload: {
        ...data,
        winnerId,
        score
      }
    });

    closeModal();
  }

  return (
    <Modal visible={visible} closeModal={closeModal}>
      <Col pad="34px 24px" center>
        <Text h3 center>
          Are you sure you want to conclude this event?
        </Text>
        <Text center marg="12px 0">
          This action is irreversable.
        </Text>

        <Text center marg="24px 0 12px" med size="18px">
          Who won?
        </Text>
        <Row gap="24px" marg="0 0 12px">
          {data.users.map((x, i) => (
            <Clickable wid="50%" onClick={() => setWinnerId(x._id)} key={i}>
              <Col pad="10px" centerAll bg={x._id === winnerId && theme.SECONDARY} hasRadius="16px">
                <Avatar user={x} />

                <Text center bold={x._id === winnerId} col={x._id === winnerId ? '#fff' : '#000'}>
                  {x.name}
                </Text>
              </Col>
            </Clickable>
          ))}
        </Row>

        <Input
          onChange={({ target }) => setScore(target.value)}
          value={score}
          marg="0 0 20px"
          title="Score (Basic explanation of the result)"
          placeholder="eg. 2 : 1, Technical KO, Round 2"
          bg="#fff"
        />

        <Row marg="12px 0 0">
          <Button text="Cancel" onClick={closeModal} marg="0 24px 0 0" />

          <Button
            disabled={!score.length}
            text="Conclude"
            bg={theme.SECONDARY}
            action="concludeEvent"
            onClick={submit}
          />
        </Row>
      </Col>
    </Modal>
  );
};

export default ConcludeModal;
